import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { ReservationStatus } from './get-reservation-dashboard'

interface DownloadReservationsCSVRequest {
  buildingId: number
  startDate?: number
  endDate?: number
  status?: ReservationStatus[]
  amenityId?: number[]
  locationId?: number[]
  search?: string
}

// Note: hits the existing `/reservation/report` endpoint (already used by the legacy
// ReservationsList.jsx) - it builds the CSV server-side (resolved names, formatted dates,
// refund/payment columns) rather than something the FE could reconstruct from the
// dashboard row shape.
export const downloadReservationsCSV = async (
  params: DownloadReservationsCSVRequest,
): Promise<Blob> => {
  const response = await authAPI.get('/reservation/report', {
    params,
    responseType: 'blob',
  })
  return response.data
}

export const useDownloadReservationsCSV = () =>
  useMutation({
    mutationFn: downloadReservationsCSV,
  })
